<template>
  <div class="form-item-checkbox">
    <input
      :id="element.metadata?.key"
      value="1"
      :name="element.metadata?.key"
      :required="element.metadata?.required ?? false"
      type="checkbox"
    >
    <label :for="element.metadata?.key">{{ element.metadata?.title }}</label>
  </div>
</template>
<script setup lang="ts">
import { type WebformElementOptionsBaseFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

defineProps<{
  element: WebformElementOptionsBaseFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-checkbox {
  @include tools.form-group-checkbox;

  &--error {
    background-color: red;
  }
}
</style>
